import { Alumni } from "iasma-datatypes";
import { createContext } from "react";

export interface MergeRecord {
	id1: number;
	id2: number;
	onClose: () => void;
}

export interface IASMAContextType {
	angkatan: number;
	setAngkatan: (x: number) => void;

	alumniList: Alumni[];
	setAlumniList: (list: Alumni[]) => void;

	mergeRecord: MergeRecord | undefined;
	setMergeRecord: (record: MergeRecord | undefined) => void;
}

export const IASMAContext = createContext<IASMAContextType | undefined>(undefined);
